import { render, staticRenderFns } from "./VUDNumbersTable.vue?vue&type=template&id=10b97e69&"
import script from "./VUDNumbersTable.vue?vue&type=script&lang=js&"
export * from "./VUDNumbersTable.vue?vue&type=script&lang=js&"
import style0 from "./VUDNumbersTable.vue?vue&type=style&index=0&id=10b97e69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports